import { Injectable } from '@angular/core';

@Injectable()
export class FiDocumentTemplateLayoutTrashBinService {
    isShow: boolean = false;
    currentList;
    currentItemIndex;
    dropItem: boolean = false;

    toggle() {
        this.isShow = !this.isShow;
    }
}
